module.exports = __webpack_public_path__ + "img/btn_LOW_lose.1a50a92e.png";